import type { Messages } from '../de';

export default {
  status: { entwurf: 'Draft', auf_dem_geraet: 'On device', erledigt: 'Done', erledigt_anders: 'Done – different' },
  phase: { wiedereinstieg: 'Comeback', grundlage: 'Base', aufbau: 'Build', spitze: 'Peak', huegel: 'Hills', tapering: 'Taper', erholung: 'Recovery' },
  devicesOr: ' or ',

  thisWeek: 'This week',
  nextWeek: 'Next week',
  lastWeek: 'Last week',
  isoWeek: 'Wk {n}',
  legendLabel: 'Status legend',
  legendDraft: 'Draft – only visible here',
  legendDevice: 'On device – Garmin or Wahoo',
  legendRoute: 'Route: dashy-dash → intervals.icu → Garmin Connect / Wahoo → device',
  whyLabel: 'Why this plan',
  whyTitle: 'Why this week looks like this',
  aiMissing: 'AI text missing: {error}',
  byRulesAi: 'Suggested by rules, text by AI',
  byRules: 'Suggested by rules',
  noSuggestion: 'No suggestion for this week yet. It is built from readiness, form, goals and streaks – always as a draft.',
  suggestWeek: 'Suggest week',
  unpushConfirm: 'Take “{title}” back from the device? The intervals.icu event is deleted, the draft stays here.',
  loadError: 'Planning can’t be loaded right now.',
  retry: 'Try again',
  loading: 'Loading …',
  kickerRace: 'Next race: {name} · {date}',
  pushNothing: 'Nothing to send to device',
  pushDrafts: { one: '1 draft: choose for device …', other: '{count} drafts: choose for device …' },
  prevWeek: 'Previous week',
  nextWeekBtn: 'Next week',
  today: 'Today',
  planning: 'Planning …',
  suggestAgain: 'Suggest again',
  drafts: { one: '{count} draft', other: '{count} drafts' },
  noDrafts: 'No open drafts',
  serieNote: ' · Run streak: streak miles planned on days without a run',
  chat: 'Chat',
  toDevice: 'To device …',
  chatSheet: 'Plan by chat',
  chatSheetBasis: 'Single workout by chat · based on last 42 days',
  chatTitle: 'Single workout by chat',

  week: 'Week',
  restDay: 'Rest day',
  unpush: 'Take back',

  chatNote: '{date} · Targets with type (e.g. Z2 HR) so the watch doesn’t use watts. It only goes to the device after your click.',
  chatReason: 'Reason: {issue}',
  chatFailed: 'That didn’t work: {error}',
  chatHint: 'Say what should go on the watch – e.g. “Put 25 min easy with 4 strides on Tuesday, HR below 138.” It lands in the plan as a draft.',
  chatOffBefore: 'AI is off. Single workouts by chat only work once an AI provider is set in the server environment (',
  chatOffAfter: ').',
  thinking: 'Thinking …',
  message: 'Message',
  messagePlaceholder: 'Message …',
  askPlaceholder: 'What should go on the watch?',
  send: 'Send',

  runWalkMeta: 'run {run} min, walk {walk} min',

  seasonTitle: 'Season',
  seasonWeek: 'This week: {phase} · ~{km}',
  seasonWeekOther: 'Week: {phase} · ~{km}',
  seasonNoWeek: 'This week is not in the grid.',
  seasonNextRace: 'Next race: {name} · {date}',
  seasonWeeksToA: { one: '{count} week to the A race', other: '{count} weeks to the A race' },
  seasonAThisWeek: 'A race this week',
  seasonEmpty: 'No races entered yet. The season plan is built from the race list.',
  seasonLink: 'Go to season',
  planStarts: 'Your plan starts on {date}.',
  planStartsText: 'Nothing is planned until then. You will find the whole plan in the season.',

  releaseTitle: { one: 'Send 1 workout to device?', other: 'Send {count} workouts to device?' },
  releaseTitleNone: 'No workout selected',
  releaseGoes: { one: 'The draft goes to {devices} via intervals.icu.', other: '{count} drafts go to {devices} via intervals.icu.' },
  releaseGoesSome: { one: '1 of {total} drafts goes to {devices} via intervals.icu.', other: '{count} of {total} drafts go to {devices} via intervals.icu.' },
  releaseNoneSelected: 'Tick what should go to the device.',
  releaseOthersHint: ' Only runs and rides are preselected; tick the rest if you want it on the device.',
  releaseList: 'Workouts for the device',
  releaseNone: 'No drafts from today on in this week.',
  releaseOnDevice: { one: ' One workout is already on the device.', other: ' {count} workouts are already on the device.' },
  intervalsOffBefore: 'intervals.icu is not connected ({reason}). Without a key everything stays a draft – set ',
  intervalsOffAfter: ' in the server environment.',
  noKey: 'no key',
  releaseInfo: 'Ticked workouts land in the calendar via intervals.icu and on the device with the next sync. You can take them back here at any time.',
  cancel: 'Cancel',
  sending: 'Sending …',
  sendToDevice: 'Send {count} to device',
  close: 'Close',
  detail: {
    open: 'Details: {title}',
    move: 'Move',
    moveTo: 'Move to {day}',
    moveHint: 'Tap another day of this week. Past days are not possible.',
    moveDevice: 'It is already on the device – intervals.icu moves it along.',
    delete: 'Delete',
    deleteDraft: 'Delete “{title}”?',
    deleteDevice: 'Delete “{title}”? It will be taken off the device too.',
    deleteYes: 'Yes, delete',
    unpushYes: 'Yes, take back',
    keep: 'Cancel',
    confirmLabel: 'Confirmation',
    toActivity: 'To the activity',
    strip: 'Week at a glance',
  },
} satisfies Messages['planning'];
